import DataGrid, {
    Column,
    ColumnChooser,
    Export,
    FilterRow,
    Pager,
    Paging,
    Scrolling,
    Selection,
  } from 'devextreme-react/data-grid';

import 'react-toastify/dist/ReactToastify.css';

import { onExporting } from '../../../shared/excel-export';
import { DATAGRID_ALLOWED_PAGE_SIZES } from '../../../constants/constant-arrays';

export default function DevextremeDataGrid(props) {
    
  return (
    <div className='m-5 user-select-none'>
      <div className='m-5'>
        <DataGrid
          id={props?.dataGridId || "grid-container"}
          className={props?.className}
          keyExpr={props?.keyExpr || "id"}
          dataSource={props.dataSource}
          onSelectionChanged={props?.onSelectionChanged}
          ref={props?.dataGridRef}
          selectedRowKeys={props?.selectedRowKeys}
          rtlEnabled={props.rtlEnabled}
          showBorders={props.showBorders}
          remoteOperations={props.remoteOperations}
          allowColumnResizing={props.allowColumnResizing}
          columnHidingEnabled={props.columnHidingEnabled}
          onExporting={onExporting}
          onRowDblClick={props?.onDoubleClick}
          >
          <Export enabled={props?.exportEnabled || false} 
            allowExportSelectedData={props?.allowExportSelectedData || false} />
          <Scrolling columnRenderingMode={props?.scrollingColumnRenderingMode || "virtual"} />
          <Selection mode={props?.selectionMode || "multiple"}/>
          <FilterRow visible={props?.filterRowVisible|| false} />
          <Paging defaultPageSize={props.pagingDefaultPageSize || 3} />
          <Pager
            showPageSizeSelector={props?.pagerShowPageSizeSelector || false}
            showNavigationButtons={props?.pagerShowNavigationButtons || false}
            showInfo={props?.pagerShowInfo || false}
            displayMode={'compact'}
            visible={"totalCount > 0"}
            allowedPageSizes={props?.allowedPageSizes || DATAGRID_ALLOWED_PAGE_SIZES}
          />
          <ColumnChooser
            enabled={props?.columnChooserEnabled || true}
            mode={props?.columnChooserSelect || 'select'}
          />
          {props.columns?.map((col, idx) => (
            <Column key={idx} {...col} />
          ))}
        </DataGrid>
      </div>
    </div>
  );

}